export default __webpack_public_path__ + "static/media/twitter.172471ff.svg";